export const HEARD_OF_COMMUNITY_AGENCY = 'Community Agency'
export const HEARD_OF_FAMILY = 'Family'
export const HEARD_OF_FRIENDS = 'Friends'
export const HEARD_OF_SCHOOL = 'School'
export const HEARD_OF_TCHC = 'TCHC'
export const HEARD_OF_COMMUNITY_CAMP_TRIP = 'Community Camp Trip'
export const HEARD_OF_EMPOWER_HER = 'Empower Her'
export const HEARD_OF_KICK_START = 'Kick Start'
export const HEARD_OF_HOME_ICE_HOCKEY = 'Home Ice Hockey'
export const HEARD_OF_MIDNIGHT_BASKETBALL = 'Midnight Basketball'
export const HEARD_OF_TORONTO_MAPLE_LEAFS_CLINIC = 'Toronto Maple Leafs Clinic'
export const HEARD_OF_TORONTO_RAPTORS_CLINIC = 'Toronto Raptors Clinic'
export const HEARD_OF_INTERNET = 'Internet'

export const HEARD_OF_OPTIONS = [
  HEARD_OF_COMMUNITY_AGENCY,
  HEARD_OF_FAMILY,
  HEARD_OF_FRIENDS,
  HEARD_OF_SCHOOL,
  HEARD_OF_TCHC,
  HEARD_OF_COMMUNITY_CAMP_TRIP,
  HEARD_OF_EMPOWER_HER,
  HEARD_OF_KICK_START,
  HEARD_OF_HOME_ICE_HOCKEY,
  HEARD_OF_MIDNIGHT_BASKETBALL,
  HEARD_OF_TORONTO_MAPLE_LEAFS_CLINIC,
  HEARD_OF_TORONTO_RAPTORS_CLINIC,
  HEARD_OF_INTERNET,
].map(e => ({
  value: e,
  label: e,
}))

export const PICK_UP_PERMISSION_ADULT_WILL_PICK_UP = 'An adult will pick up the child from program each day'
export const PICK_UP_PERMISSION_CHILD_MAY_TRAVEL = 'Child may travel to and from the facility independently'
export const PICK_UP_PERMISSION_OPTIONS = [
  PICK_UP_PERMISSION_ADULT_WILL_PICK_UP,
  PICK_UP_PERMISSION_CHILD_MAY_TRAVEL,
].map(e => ({
  value: e,
  label: e,
}))

export const REASON_FOR_JOINING_SPORT = 'Sport'
export const REASON_FOR_JOINING_MENTAL_WELLNESS_SUPPORT = 'Mental Wellness Support'
export const REASON_FOR_JOINING_ACADEMIC_SUPPORT = 'Academic Support'
export const REASON_FOR_JOINING_EMPLOYMENT_SUPPORT = 'Employment Support'
export const REASON_FOR_JOINING_OTHER = 'Other'

export const REASON_FOR_JOINING_OPTIONS = [
  REASON_FOR_JOINING_SPORT,
  REASON_FOR_JOINING_MENTAL_WELLNESS_SUPPORT,
  REASON_FOR_JOINING_ACADEMIC_SUPPORT,
  REASON_FOR_JOINING_EMPLOYMENT_SUPPORT,
  REASON_FOR_JOINING_OTHER,
].map(e => ({
  value: e,
  label: e,
}))

export const PROFILE_COMPLETENESS_PICK_UP_PERMISSION_FIELDS = ['pick_up_permission']

export const PROFILE_COMPLETENESS_ROLE_OF_FIELDS = ['heard_of', 'reason_for_joining']

export const PROFILE_COMPLETENESS_ADD_PROFILE_PICTURE_FIELDS = ['photo_url']

export const PROFILE_COMPLETENESS_MEDICAL_CONSIDERATION_FIELDS = [
  'has_allergies',
  'has_epi_pen',
  'has_medications',
  'impact_on_ability_to_participate',
  'how_we_can_support',
]

export const PROFILE_COMPLETENESS_PERSONAL_INFO_FIELDS = [
  'first_name',
  'last_name',
  'gender',
  'name',
  'member_id',
  'pronoun',
  'dob',
  'race',
  'school_name',
  'household_income',
  'birthplace_canada',
  'grade',
]

export const PROFILE_COMPLETENESS_CONTACT_DETAILS_FIELDS = ['contact_name', 'phone_number', 'email']

export const PROFILE_COMPLETENESS_FIELDS = PROFILE_COMPLETENESS_PICK_UP_PERMISSION_FIELDS.concat(
  PROFILE_COMPLETENESS_ROLE_OF_FIELDS,
  PROFILE_COMPLETENESS_ADD_PROFILE_PICTURE_FIELDS,
  PROFILE_COMPLETENESS_PERSONAL_INFO_FIELDS,
  PROFILE_COMPLETENESS_CONTACT_DETAILS_FIELDS,
  PROFILE_COMPLETENESS_MEDICAL_CONSIDERATION_FIELDS,
)

export const PROFILE_COMPLETENESS_DEFAULT_REQUIRED_FIELDS = ['photo_url', 'first_name', 'last_name', 'name', 'dob']

export const REGISTRATION_INFO_PERSONAL_INFO_FIELDS = [
  'member_id',
  'gender',
  'pronoun',
  'birthplace_canada',
  'race',
  'school_name',
  'grade',
  'household_income',
]

export const REGISTRATION_INFO_MEDICAL_CONSIDERATION_FIELDS = [
  'has_allergies',
  'has_epi_pen',
  'has_medications',
  'medical_conditions',
  'impact_on_ability_to_participate',
  'how_we_can_support',
]

export const REGISTRATION_INFO_CONTACT_DETAILS_FIELDS = [
  'pickup_contacts_contact_name',
  'pickup_contacts_phone_number',
  'pickup_contacts_email',
  'preferred_contact',
]

export const REGISTRATION_INFO_ADDRESS_FIELDS = ['street_address', 'unit', 'city', 'state', 'postal_code']

export const REGISTRATION_INFO_PICK_UP_PERMISSION_FIELDS = ['pick_up_permission']

export const REGISTRATION_INFO_ROLE_OF_FIELDS = ['heard_of', 'reason_for_joining']

export const SUCCESS_COLOR = '#31C09F'
export const SUCCESS_THRESHOLD = 100
export const WARNING_COLOR = '#FFCA64'
export const WARNING_THRESHOLD = 85
export const DANGER_COLOR = '#DD5151'
export const DANGER_THRESHOLD = 65


export const FLAG_WARNING_COLOR = '#FAAE54'
export const FLAG_DANGER_COLOR = '#EA5959'
